import React from "react";

const Title = ({title}) => {
    return <div>
        <p className="text-4xl font-bold border-b-4 border-gray-500
    p-2 inline">{title}</p>
    </div>
}

export default Title;
